import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer, useLocalStore } from 'mobx-react';
import type { UserLab } from 'types/labs';
import { LabCardRow } from '../../LabCard';
import type LabEnvironmentStore from '../../store';
import LabWebApplicationsStore from './store';

type LabWebAppsProps = {
  labStore: LabEnvironmentStore;
};

const LabWebApps: React.FC<LabWebAppsProps> = ({ labStore }) => {
  const { t } = useTranslation();
  const store = useLocalStore(() => new LabWebApplicationsStore());
  const isExpanded = (id: string) => store.expandedPanels?.has(id);
  const userLab = labStore.userLab as UserLab;
  const labWebApplications = userLab.web_applications;

  if (!labWebApplications?.length) {
    return null;
  }

  return (
    <>
      {labWebApplications.map((webApplication) => (
        <LabCardRow
          key={webApplication.url}
          label={webApplication.title || t('Classroom Webapp')}
          actionLabel={t('Access')}
          onActionClick={() => window.open(webApplication.url, '_blank')}
          isExpanded={isExpanded(webApplication.url)}
          onToggle={() =>
            store.togglePanels(
              webApplication.url,
              !isExpanded(webApplication.url),
            )
          }
          analyticsId="lab-ctrl-acc-vt-dash-lp"
        >
          {webApplication.description ? (
            <p>{webApplication.description}</p>
          ) : null}
        </LabCardRow>
      ))}
    </>
  );
};

export default observer(LabWebApps);
